import Header from "./Header";
import Footer from "./Footer";
import './PrivacyPolicy.css';
import PrivacyPolicyH2Webp from '../img/Privacy-policy-h2.webp';
import PrivacyPolicyH2 from '../img/Privacy-policy-h2.png';

export default function PrivacyPolicy() {
    return (
        <div>
            <Header />
            <div className="PrivacyPolicy">
                <div className="PrivacyPolicy__h2">
                    <picture>
                        <source type="image/webp" srcSet={PrivacyPolicyH2Webp} />
                        <img src={PrivacyPolicyH2} alt="Privacy policy" />
                    </picture>
                </div>
                <h3>Contact informaton</h3>
                <p>Data Controller<br />
                    721 Genesis Ltd is responsible for your personal data as a controller.<br />
                    If you have any questions or would like to uphold your rights,
                </p>
                <p>please contact us here:<br />
                    Discord ：bit.ly/3OSPd7W
                </p>

                <h3>Provision of personal data</h3>
                <p>You are required to provide us with certain personal data when you sign in our Services.</p>
                <p>Personal data that is mandatory is indicated the relevant forms. We are not able to provide our Services to
                    you such data is not provided.</p>

                <h3>How we use your personal data</h3>
                <p>We use personal data for the following purposes:</p>
                <p>(a) to take and handle orders, provide NFT avatars and services, and process payment. The lawful basis for
                    these uses is to perform our contract with you.</p>
                <p>(b) to communicate with you about orders and services. The lawful basis for these uses is to perform our
                    contract with you. To comply with our legal obligations or to pursue our legitimate interests in improving
                    our Services and giving our users the best experience.</p>
                <p>(c) to decide which information to show you, where you give us your consent. The lawful basis for this use is
                    your consent.</p>
                <p>(d) to protect our customers from fraudulent, unauthorized or illegal activity on our Services and to respond
                    to requests by the government or law enforcement authorities conducting an investigation. The lawful basis
                    for these uses is our legal obligations.</p>

                <h3>How we share your personal data</h3>
                <p>We share your personal data with the following recipients:</p>
                <p>(a) Any of our Group Companies: and</p>
                <p>(b) Our service providers that provide services on our behalf, such as tech vendors who support our websites
                    and other business systems, operational companies, and payment providers who help us process your payments.
                    Our service providers are located in United Kingdom.</p>

                <h3>International data transfers</h3>
                <p>The third parties to which we transfer your personal data in order to provide our services, except for our
                    Group Companies located in the EU and UK, located in Japan and Dubai.</p>
                <p>For further information, including obtaining a copy of the documents used to protect your personal data,
                    please contact us in writing at the email to the email address listed in Contact Information above.</p>

                <h3>Data retention</h3>
                <p>We retain your personal data for a period of 3 months maximum after your account is deleted, except where
                    legal requirements imposing that we keep your personal data longer or less longer apply.</p>

                <h3>Your rights</h3>
                <p>You have the rights to ask us: for a copy of your personal data: to correct or delete your personal data: to
                    restrict (stop any active) processing of your personal data: and to send you a copy of your personal data
                    you have provide to us in a structured, machine readable format. In addition, you can object to the
                    processing of your personal data under certain conditions. To exercise any of these rights, please contact
                    us in writing at the email address listed in Contact Information above.</p>

                <h3>Your right to object to processing</h3>
                <p>You have the right to object at any time to the processing of your personal data which is based on our
                    legitimate interests, including profiling (i.e. analyzing or predicting your behavior based on your
                    information). When we process your personal data for direct marketing purposes, you have an absolute right
                    to opt out of such processing. To exercise this right, please contact us in writing at the email address
                    listed in Contact Information above.</p>

                <h3>Withdrawing consent</h3>
                <p>Whenever we rely on your consent in order to process your personal data, you have the right to withdraw that
                    consent at any time. Such withdrawal does not affect the lawfulness of any processing performed pursuant to
                    the consent given prior to the withdrawal.</p>
                <p>To exercise this right, please contact us in writing at the email address listed in Contact Information
                    above.</p>

                <h3>Your right to complain to a supervisory authority</h3>
                <p>You have the right to lodge a complaint with a supervisory authority, in particular, in the member state of
                    the EU or the UK where you have a habitual residence or place of work or where the alleged infringement of
                    the GDPR took place.</p>
            </div>
            <Footer />
        </div>
    );
}